import { createApp } from '@app/adapters/create-app'
import BudgetActionsSelect from '../sections/budget-actions-select'

const renderBudgetActionsSelect = (tableStructure) => {
  document
    .querySelectorAll('[data-behaviour="budget-actions-select"]')
    .forEach((element) => {
      createApp(BudgetActionsSelect, {
        rowType: element.dataset.rowType,
        rowElementId: element.dataset.rowElementId,
        tableStructure: tableStructure,
        defaultValues: {
          copyValue: element.dataset.defaultCopyValue,
          divider: element.dataset.defaultDivider,
          spreadValue: element.dataset.defaultSpreadValue,
          seasonality: '100',
        },
      }).mount(element)
    })
}

const handleAccountClick = (event) => {
  event.preventDefault()

  const { reportId, accountId, ledgerId, relative, value } =
    event.currentTarget.dataset

  window.modalCitizen.openModalPortal('report-account-details-modal', {
    reportId: Number(reportId),
    accountId: Number(accountId),
    ledgerId: Number(ledgerId),
    relative,
    value,
  })
}

onDomLoad(function () {
  if (!document.querySelector('.budget-table')) return

  const table = document.querySelector('[data-table-structure]')
  const tableStructure = JSON.parse(table.dataset.tableStructure)

  renderBudgetActionsSelect(tableStructure)

  document
    .querySelectorAll('[data-behaviour="account-open-modal"]')
    .forEach((element) => {
      element.addEventListener('click', handleAccountClick)
    })
})
